import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { IRequestAndLineType } from '../models/request-line-types.model';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { ReactiveFormsModule } from '@angular/forms';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatButtonModule } from '@angular/material/button';
import { RequestAndLineTypeService } from '../services/request-and-line-types.service';
import { ManageRequestTypeComponent } from './manage-request-type/manage-request-type.component';
import { MatDialog } from '@angular/material/dialog';
import { ManageLineTypeComponent } from './manage-line-types/manage-line-type.component';

@Component({
  selector: 'request-line-types',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, ReactiveFormsModule, MatButtonModule],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*', paddingBottom: '25px'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  templateUrl: './request-line-types.component.html',
  styleUrl: './request-line-types.component.scss'
})
export class RequestLineTypesComponent implements OnInit {

  user: ILoggedInUser;
  isAdmin: boolean;
  dataSource: IRequestAndLineType[] = [];
  loading: boolean = true;
  columnsToDisplay: string[] = ['type', 'forMode', 'forEmployeeType'];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  innerDisplayedColumns: string[] = ['description', 'forMode', 'forEmployeeType', 'forEmployeeCategory', 'go165Required', 'rate', 'limit'];
  expandedElement: IRequestAndLineType | null;

  constructor(
    private userService: LoggedInUserService,
    private requestAndLineTypeService: RequestAndLineTypeService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;
        this.requestAndLineTypeService.getRequestLineTypes().subscribe(
          data => {
            this.dataSource = data;
            this.loading = false;
          }
        );
      } else {
        this.loading = false;
      }
    });
  }

  editRequestType(requestType: string): void {
    this.dialog.open(ManageRequestTypeComponent, {
      data: { requestType: requestType, isEdit: true }
    });

    this.dialog.afterAllClosed.subscribe(() => {
      this.loadData();
    });
  }

  editLineType(requestType: string, lineType: string): void {
    this.dialog.open(ManageLineTypeComponent, {
      data:{
        requestType: requestType,
        lineType: lineType,
        isEdit: true}      
     });

     this.dialog.afterAllClosed.subscribe(() => {
      this.loadData();
    });
  }

  newRequestType(): void {
    if(this.isAdmin){
      this.dialog.open(ManageRequestTypeComponent, {
        data: { requestType: '', isEdit: false }
      });

      this.dialog.afterAllClosed.subscribe(() => {
        this.loadData();
      });
    }
  }

  newLineType(): void {
    if(this.isAdmin){
      this.dialog.open(ManageLineTypeComponent, {
        data:{
          requestType: '',
          lineType: '',
          isEdit: false}
      });

      this.dialog.afterAllClosed.subscribe(() => {
        this.loadData();
      });
    }    
  }
}